import docReady from '@/js/helpers/doc-ready'

docReady(() => {
  if (window.document.documentMode) {
    document.body.classList.add('body--ie')
  }
})
